/**
 * The synthetic module's routes, owned by the feature. Same shape as audit's and kyc's.
 *
 * Three routes, three templates: the tabbed panel at `/shipments/generate`, the standalone list at
 * `/shipments/synthetic-drafts`, and the editor at `/shipments/synthetic-drafts/:id`. They stay on
 * the paths they had — `AdminLayout`'s "Envíos Sintéticos" entry points at the first and lights up
 * on the second through its `matchPaths`.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const GenerateSyntheticPage = lazy(() => import('./GenerateSyntheticPage'));
const SyntheticDraftsPage = lazy(() => import('./SyntheticDraftsPage'));
const SyntheticDraftDetailPage = lazy(() => import('./SyntheticDraftDetailPage'));

export const syntheticRoutes: RouteObject[] = [
    { path: 'shipments/generate', element: <GenerateSyntheticPage /> },
    { path: 'shipments/synthetic-drafts', element: <SyntheticDraftsPage /> },
    { path: 'shipments/synthetic-drafts/:id', element: <SyntheticDraftDetailPage /> },
];
